export default __webpack_public_path__ + "static/media/Balsa.f218bcde.svg";